export const useExternalUrl = () => {
  // Cabinet currently serves only English, regardless of the landing locale.
  const baseUrl = "https://cabinet.tradeview.eu";

  const getExternalUrl = (path = "") => {
    const normalizedPath = path && !path.startsWith("/") ? `/${path}` : path;

    return `${baseUrl}${normalizedPath}`;
  };

  return { getExternalUrl };
};
